import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef, frefToRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {CustomScrollbarTrackVisibility, CustomScrollbarProps} from '../../../lib/custom-scrollbar/custom-scrollbar';
import retardUpdate from '../../../lib/react/update-retarder';
import {OEBottomWidgetToolbarLayoutType} from './oe-bottom-widget-toolbar-model';
import {OEMediaCenterPropTypes, OEMediaCenterConfigFactory} from '../../controller/media-center/oe-media-center-model';
import OEMediaCenterItemCollection from '../../controller/media-center/components/oe-media-center-item-collection';
import {OEPresentationSlideMagnificationPlacement} from '../../controller/presentation/oe-presentation-slide-magnification';

export class OEMediaCenterItemToolbar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this._shouldBeVisible = false;

        this.items = [];

        this.state = {
            uiEnabled: false,
            items: [],
            selectedItemIndex: -1
        };

        this.onActualMediaCenterItemChanged = this.onActualMediaCenterItemChanged.bind(this);
        this.onActualMediaCenterSubItemChanged = this.onActualMediaCenterSubItemChanged.bind(this);
        this.onMediaCenterItemAdded = this.onMediaCenterItemAdded.bind(this);
        this.onMediaCenterItemRemoved = this.onMediaCenterItemRemoved.bind(this);
        this.onMediaCenterItemMoved = this.onMediaCenterItemMoved.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onItemClicked = this.onItemClicked.bind(this);
    }

    shouldBeVisible()   {
        return this._shouldBeVisible;
    }

    allowedLayoutTypes()    {
        return [OEBottomWidgetToolbarLayoutType.horizontal, OEBottomWidgetToolbarLayoutType.vertical];
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.category != this.props.category || nextProps.categoryName != this.props.categoryName) {
            this.updateItems(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterItemAdded, this.onMediaCenterItemAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterItemRemoved, this.onMediaCenterItemRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterItemMoved, this.onMediaCenterItemMoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterItemAdded, this.onMediaCenterItemAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterItemRemoved, this.onMediaCenterItemRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterItemMoved, this.onMediaCenterItemMoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateShouldBeVisible() {
        let shouldBeVisible = false;

        if(this.oe.isReady())   {
            let si = this.oe.sharedInterface;
            shouldBeVisible = !si.getUIControllerVisible(this.oe.Module.UIControllerType.presentation) && !si.getUIControllerVisible(this.oe.Module.UIControllerType.media_center);
        }

        if(this._shouldBeVisible != shouldBeVisible) {
            this._shouldBeVisible = shouldBeVisible;
            if(this.props.onShouldBeVisibleChanged)  this.props.onShouldBeVisibleChanged(this, shouldBeVisible);
        }
    }

    updateItems(props)  {
        props = props || this.props;
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();

        //
        this.items = props.categoryName ? controller.getCategoryMediaItemsForName(props.categoryName) : controller.getCategoryMediaItems(props.category);

        //
        let idItemMap = {};
        this.items.forEach((ids) => {
            let id = ids.id.toString() + '_' + ids.subId.toString();
            idItemMap[id] = controller.mediaItemIDPair(ids);
        });

        //
        if(Array.isArray(props.categoryMaskOrder))  {
            this.items.sort((l, r) => {
                let lItem = idItemMap[l.id.toString() + '_' + l.subId.toString()];
                let rItem = idItemMap[r.id.toString() + '_' + r.subId.toString()];

                let iL = -1, iR = -1;
                props.categoryMaskOrder.forEach((mask, i) => {
                    if(lItem && (mask & lItem.categoryMask))    iL = i;
                    if(rItem && (mask & rItem.categoryMask))    iR = i;
                });

                if(iL < 0)  iL = props.categoryMaskOrder.length;
                if(iR < 0)  iR = props.categoryMaskOrder.length;

                return iL - iR;
            });
        }

        //
        let items = [];
        this.items.forEach((ids) => {
            let item = idItemMap[ids.id.toString() + '_' + ids.subId.toString()];
            if(item !== null)   items.push(item);
        });

        //
        this.setState({items: items});

        //
        this.updateSelectedItemIndex();
    }

    determineSelectedItemIndex()  {
        if(!this.oe.isReady())  return -1;
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();

        let activeItemId = {id: controller.getActualMediaItemID(), subId: controller.getActualMediaSubItemID()};

        for(let i = 0; i < this.items.length; i++)  {
            let itemId = this.items[i];
            if(itemId.id === activeItemId.id && itemId.subId === activeItemId.subId)    return i;
        }

        for(let i = 0; i < this.items.length; i++)  {
            let itemId = this.items[i];
            if(itemId.id === activeItemId.id && itemId.subId === -1)    return i;
        }

        return -1;
    }

    updateSelectedItemIndex()    {
        this.setState({selectedItemIndex: -1 /*this.determineSelectedItemIndex()*/});
    }

    updateUIState()   {
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        this.setState({
            uiEnabled: controller.getUIEnabled() && controller.getUIPresentable()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.items = [];
            this.updateShouldBeVisible();
            this.setState({uiEnabled: false, items: [], selectedItemIndex: -1});
            return;
        }

        retardUpdate(this, () => {
            this.updateShouldBeVisible();
            this.updateUIState();
            this.updateItems();
        });
    }

    onActualMediaCenterItemChanged()    {
        this.updateSelectedItemIndex();
    }

    onActualMediaCenterSubItemChanged() {
        this.updateSelectedItemIndex();
    }

    onMediaCenterItemAdded()    {
        this.updateItems();
    }

    onMediaCenterItemRemoved()    {
        this.updateItems();
    }

    onMediaCenterItemMoved()    {
        this.updateItems();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.media_center || userInfo.type === this.oe.Module.UIControllerType.presentation) {
            this.updateShouldBeVisible();
            this.updateUIState();
        }
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className={'media-center-item-toolbar ' + this.props.className}>
                    <OEMediaCenterItemCollection
                        moduleId={this.props.moduleId}
                        className={this.props.innerClassName}
                        config={{
                            usePresItems: false,
                            showIndex: this.props.showIndex,
                            forceShowIndex: this.props.forceShowIndex,
                            showIcon: this.props.showIcon,
                            showLabel: this.props.showLabel,
                            showStats: this.props.showStats,
                            noImages: this.props.noImages,
                            noPresThumbImages: this.props.noPresThumbImages,
                            presPlayableFlags: this.props.mediaCenterConfig.presPlayableFlags
                        }}
                        enabled={this.state.uiEnabled}
                        items={this.state.items}
                        selectedItemIndex={this.props.selectActive ? this.state.selectedItemIndex : -1}
                        magnification={this.props.magnification}
                        magnificationPlacement={this.props.magnificationPlacement}
                        scrollbar={this.props.scrollbar}
                        onClick={this.onItemClicked}
                    />
                </div>

            </React.Fragment>
        );
    }

    onItemClicked(index, id)   {
        if(!this.oe.isReady())  return;
        let si = this.oe.sharedInterface;
        let mc = si.getUIControllerMediaCenter();

        if(this.props.categoryName) {
            let category = mc.getCategoryIndexForName(this.props.categoryName);
            if(category >= 0)   mc.setActualCategory(category);
        } else {
            mc.setActualCategory(this.props.category);
        }
        
        mc.setActualMediaItemID(id);

        // set ui visible after setActualMediaItemID due to analytics tracker "presentationInMediaCenterSelected" event trigger
        mc.setUIVisible(true);

        if(this.props.appComponent && this.props.appComponent.mediaCenter)   {
            if(this.props.autoplay)    {
                this.props.appComponent.mediaCenter.play(true);
            } else {
                this.props.appComponent.mediaCenter.setDirectPlay(true);
            }
        }
    }
}

OEMediaCenterItemToolbar.defaultProps = {
    moduleId:                           '',
    className:                          '',
    category:                           0,
    selectActive:                       true,
    visible:                            false,
    showIndex:                          true,
    forceShowIndex:                     false,
    showIcon:                           false,
    showLabel:                          true,
    showStats:                          true,
    noImages:                           false,
    noPresThumbImages:                  true,
    autoplay:                           false,
    mediaCenterConfig:                  OEMediaCenterConfigFactory.std(),
    magnification:                      1.65,
    magnificationPlacement:             OEPresentationSlideMagnificationPlacement.top,
    scrollbar: {
        horizontalTrackVisiblity:       CustomScrollbarTrackVisibility.always,
        verticalTrackVisiblity:         CustomScrollbarTrackVisibility.none,
    }
};

OEMediaCenterItemToolbar.propTypes = {
    moduleId:                           PropTypes.string,
    className:                          PropTypes.string,
    innerClassName:                     PropTypes.string,
    category:                           PropTypes.number,
    categoryName:                       PropTypes.string,
    categoryMaskOrder:                  PropTypes.arrayOf(PropTypes.number),
    selectActive:                       PropTypes.bool,
    visible:                            PropTypes.bool,
    showIndex:                          PropTypes.bool,
    forceShowIndex:                     PropTypes.bool,
    showIcon:                           PropTypes.bool,
    showLabel:                          PropTypes.bool,
    showStats:                          PropTypes.bool,
    noImages:                           PropTypes.bool,
    noPresThumbImages:                  PropTypes.bool,
    autoplay:                           PropTypes.bool,
    mediaCenterConfig:                  OEMediaCenterPropTypes.configDecl,
    magnification:                      PropTypes.number,
    magnificationPlacement:             PropTypes.oneOf(OEPresentationSlideMagnificationPlacement.all),
    scrollbar:                          CustomScrollbarProps.propsDecl,
    onShouldBeVisibleChanged:           PropTypes.func,
};

//
export default frefFromRef(connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    const ret = {
        appComponent:                   env.component,
        mediaCenterConfig:              ui.mediaCenter,
        magnification:                  ui.mediaCenter.presMagnification
    };
    return ret;
})(frefToRef(OEMediaCenterItemToolbar)));